/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
import React from 'react';

import { type NewCoreIconProps } from '@atlaskit/icon';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { token } from '@atlaskit/tokens';

export const AtlassianIntelligenceLogoDark = (props: NewCoreIconProps) => (
	<AtlassianIntelligenceIcon color={token('color.icon')} {...props} />
);
